// QuestionTable.tsx
import { DxDiagnosisResultStep } from '@src/api/company/dxDiagnosis/dxDiagnosisResultApiClient.ts';
import React from 'react';

type QuestionItem = {
  id: number;
  question: string;
  answer: string;
  score: number;
};

type Props = {
  questions: QuestionItem[];
};

const formatStepQuestionData = (stepData: DxDiagnosisResultStep): QuestionItem[] => {
  if (!stepData.questions) {
    return [];
  }
  return stepData.questions.map((item) => ({
    id: item.question_no,
    question: item.question_text,
    answer: item.answer.chosen_text,
    score: item.answer.score,
  }));
};

const QuestionTable: React.FC<Props> = ({ questions }) => {
  return (
    <div className='w-full overflow-x-auto'>
      <table className='w-full'>
        <colgroup>
          <col
            style={{
              width: '80px',
            }}
          />
          <col
            style={{
              width: 'calc(100%-460px)',
            }}
          />
          <col
            style={{
              width: '300px',
            }}
          />
          <col
            style={{
              width: '80px',
            }}
          />
        </colgroup>
        <thead className='border border-solid border-gray-200 bg-gray-50'>
          <tr className='text-left text-xs [&>th]:px-4 [&>th]:py-3 [&>th]:font-semibold'>
            <th className=''>設問No.</th>
            <th className=''>設問</th>
            <th className=''>回答</th>
            <th className=''>スコア</th>
          </tr>
        </thead>
        <tbody className='bg-white text-sm'>
          {questions.map((item) => (
            <tr
              key={item.id}
              className='[&:nth-child(2n)]:bg-gray-10 [&>td]:px-4 [&>td]:py-5'
            >
              <td className=''>{item.id}</td>
              <td className='whitespace-normal break-all'>{item.question}</td>
              <td className='whitespace-normal break-all'>{item.answer}</td>
              <td className=''>{item.score}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// DXマインド
export const ContentsDxMind = ({ stepData }: { stepData: DxDiagnosisResultStep }) => {
  return <QuestionTable questions={formatStepQuestionData(stepData)} />;
};

// ブランディング
export const ContentsBranding = ({ stepData }: { stepData: DxDiagnosisResultStep }) => {
  return <QuestionTable questions={formatStepQuestionData(stepData)} />;
};

// DX戦略立案
export const ContentsDxPlanning = ({ stepData }: { stepData: DxDiagnosisResultStep }) => {
  return <QuestionTable questions={formatStepQuestionData(stepData)} />;
};

// 既存事業変革
export const ContentsInnovation = ({ stepData }: { stepData: DxDiagnosisResultStep }) => {
  return <QuestionTable questions={formatStepQuestionData(stepData)} />;
};

// 新規事業開発
export const ContentsDevelopment = ({ stepData }: { stepData: DxDiagnosisResultStep }) => {
  return <QuestionTable questions={formatStepQuestionData(stepData)} />;
};

// 事業継続
export const ContentsContinuation = ({ stepData }: { stepData: DxDiagnosisResultStep }) => {
  return <QuestionTable questions={formatStepQuestionData(stepData)} />;
};
